import { createAction } from "redux-actions";
import { urlVerificarPermisosPagina } from "../../constants/urls";
import { isTrue } from "../../utils/validaciones";

export const CHECK_PERMISO_REQUEST = "CHECK_PERMISO_REQUEST";
export const CHECK_PERMISO_SUCCESS = "CHECK_PERMISO_SUCCESS";
export const CHECK_PERMISO_FAIL = "CHECK_PERMISO_FAIL";
export const CLEAR_PERMISOS = "CLEAR_PERMISOS";

export const clearPermisos = createAction(CLEAR_PERMISOS);
export const checkPermisoRequest = createAction(CHECK_PERMISO_REQUEST);
export const checkPermisoFail = createAction(CHECK_PERMISO_FAIL);

export const checkPermisoSuccess = createAction(
    CHECK_PERMISO_SUCCESS,
    (permitidos) => permitidos,
    (permitidos, meta) => meta
);

export const checkPermiso = (userId, url) => async (dispatch) => {
    dispatch(checkPermisoRequest());
    try {
        await fetch(urlVerificarPermisosPagina, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                userId,
                url,
            }),
        })
            .then(res => res.json())
            .then(async (data) => {
                if (isTrue(data)) {
                    dispatch(checkPermisoSuccess(true, { url }));
                } else {
                    dispatch(checkPermisoSuccess(false, { url }));
                }
            }).catch((e) => {
                dispatch(checkPermisoFail(`Error al verificar permisos: ${e}`));
            }); 
    } catch (error) {
        dispatch(checkPermisoFail(error.message));
    }
};